import React, { useState, useEffect } from 'react';

import { storage } from './firebase'; // ← IMPORTANT: Adjust path based on your folder structure
import { ref, getDownloadURL } from 'firebase/storage'; // ← IMPORTANT: Add this

const API_URL = `/api/lease-to-own-documents`;

function LeaseToOwnAgreementView() {
  const [doc, setDoc] = useState({ notes: [] });
  const [loading, setLoading] = useState(true);
  const [hoveredNote, setHoveredNote] = useState(null);
  const [downloading, setDownloading] = useState(false);
 
 
useEffect(() => {
  let mounted = true;
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 10000);

  const load = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || `${process.env.REACT_APP_API_URL}`;

      const res = await fetch(`${apiUrl}${API_URL}`, {
        signal: controller.signal,
        headers: {
          Accept: 'application/json',
          'X-API-Key': process.env.REACT_APP_VEHICLES_API_KEY || '',
        },
        mode: 'cors',
      });

      clearTimeout(timeoutId);

      if (!res.ok) {
        if (res.status === 401) throw new Error('Unauthorized - invalid/missing API key');
        throw new Error(`HTTP error! Status: ${res.status}`);
      }

      const json = await res.json();

      if (mounted) {
        if (json.success && json.data) {
          setDoc(json.data);
        } else {
          console.error('Invalid response format');
        }
      }
    } catch (err) {
      if (mounted && err.name !== 'AbortError') {  // ← FIX: Don't log AbortError
        console.error(
          err.name === 'AbortError'
            ? 'Request timed out'
            : err.message || 'Failed to load agreement'
        );
      }
    } finally {
      if (mounted) setLoading(false);
    }
  };

  load();

  return () => {
    mounted = false;
    clearTimeout(timeoutId);  // ← FIX: Clear timeout before aborting
    controller.abort();
  };
}, []);
const handleDownload = async () => {
  if (!doc.fileURL) return;
  
  setDownloading(true);
  try {
    const urlParts = doc.fileURL.split('/o/')[1];
    const pathWithToken = urlParts.split('?')[0];
    const filePath = decodeURIComponent(pathWithToken);
    
    const fileRef = ref(storage, filePath);
    const downloadURL = await getDownloadURL(fileRef);
    
    // Open in new tab - browser handles download
    window.open(downloadURL, '_blank');
    
    // Or force download with a link
    const link = document.createElement('a');
    link.href = downloadURL;
    link.download = doc.fileName || 'Lease_to_Own_Agreement.docx';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
  } catch (error) {
    console.error('Download failed:', error);
    alert('Failed to download document. Please try again.');
  } finally {
    setDownloading(false);
  }
};

  if (loading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: 'linear-gradient(to bottom, #0F1419, #1A1F2E)',
        color: '#C7B381',
        fontSize: '2rem',
        fontWeight: '300',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      }}>
        Loading agreement...
      </div>
    );
  }

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(to bottom, #0F1419, #1A1F2E)',
      color: '#E8E8E8',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{ padding: '6rem 2rem 8rem', maxWidth: '1400px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '6rem' }}>
          <div style={{
            display: 'inline-block',
            color: '#C7B381',
            fontSize: '0.8rem',
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            marginBottom: '1.5rem',
            fontWeight: '500'
          }}>
            Lease Agreement
          </div>
          <h1 style={{ 
            fontSize: 'clamp(2.5rem, 6vw, 4rem)', 
            fontWeight: '300', 
            marginBottom: '1.5rem',
            color: '#FFFFFF',
            letterSpacing: '-0.01em'
          }}>
            Lease-to-Own <span style={{ fontWeight: '600', color: '#C7B381' }}>Agreement</span>
          </h1>
          <p style={{ 
            fontSize: 'clamp(1rem, 2vw, 1.2rem)', 
            color: '#B8B8B8', 
            maxWidth: '700px', 
            margin: '0 auto',
            lineHeight: '1.8',
            fontWeight: '300',
            padding: '0 1rem'
          }}>
            Please review the lease-to-own terms and conditions before proceeding.
          </p>
        </div>

        {/* Document Download Section */}
        {doc.fileURL ? (
          <div style={{ 
            background: 'rgba(15, 20, 25, 0.6)',
            border: '1px solid rgba(199, 179, 129, 0.15)',
            borderRadius: '16px',
            padding: 'clamp(2rem, 4vw, 3rem)', 
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)', 
            marginBottom: '4rem',
            textAlign: 'center'
          }}>
            
            <h2 style={{ 
              fontSize: 'clamp(1.5rem, 3vw, 2rem)', 
              marginBottom: '1rem', 
              color: '#C7B381',
              fontWeight: '400',
              letterSpacing: '-0.01em'
            }}>
              Lease-to-Own Agreement Document
            </h2>
            
            {doc.fileName && (
              <p style={{ 
                color: '#888',
                fontSize: 'clamp(0.9rem, 1.5vw, 1.1rem)',
                marginBottom: '2.5rem',
                letterSpacing: '0.05em'
              }}>
                {doc.fileName}
              </p>
            )}

            <button
              onClick={handleDownload}
              disabled={downloading}
              style={{
                padding: 'clamp(1rem, 2vw, 1.2rem) clamp(2.5rem, 5vw, 4rem)',
                background: downloading ? '#888' : '#C7B381',
                color: '#0F1419',
                border: 'none',
                borderRadius: '8px',
                fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                fontWeight: '600',
                cursor: downloading ? 'not-allowed' : 'pointer',
                boxShadow: '0 4px 15px rgba(199, 179, 129, 0.3)',
                transition: 'all 0.3s ease',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '1rem'
              }}
              onMouseEnter={(e) => {
                if (!downloading) {
                  e.target.style.transform = 'translateY(-3px)';
                  e.target.style.background = '#D4C599';
                  e.target.style.boxShadow = '0 6px 20px rgba(199, 179, 129, 0.5)';
                }
              }}
              onMouseLeave={(e) => {
                if (!downloading) {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.background = '#C7B381';
                  e.target.style.boxShadow = '0 4px 15px rgba(199, 179, 129, 0.3)';
                }
              }}
            >
              <span style={{ fontSize: '1.3em' }}>{downloading ? '⏳' : '⬇️'}</span> 
              <span>{downloading ? 'Downloading...' : 'Download Agreement'}</span>
            </button>
          </div>
        ) : (
          <div style={{ 
            background: 'rgba(15, 20, 25, 0.6)',
            border: '1px solid rgba(199, 179, 129, 0.15)',
            borderRadius: '16px',
            padding: 'clamp(3rem, 6vw, 5rem)',
            textAlign: 'center',
            marginBottom: '4rem',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
          }}>
            <div style={{ 
              fontSize: 'clamp(3rem, 6vw, 4rem)',
              marginBottom: '1.5rem',
              opacity: 0.3
            }}>
              📭
            </div>
            <p style={{ 
              color: '#888', 
              fontSize: 'clamp(1rem, 2vw, 1.2rem)',
              marginBottom: '0.5rem'
            }}>
              No agreement document available at this time.
            </p>
            <p style={{ 
              color: '#666', 
              fontSize: 'clamp(0.9rem, 1.5vw, 1rem)'
            }}>
              Please check back later or contact support.
            </p>
          </div>
        )}

        {/* Notes Section */}
        {doc.notes && doc.notes.length > 0 && (
          <div style={{ 
            background: 'rgba(15, 20, 25, 0.6)',
            border: '1px solid rgba(199, 179, 129, 0.15)',
            borderRadius: '16px',
            padding: 'clamp(1.5rem, 3vw, 2.5rem)', 
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)' 
          }}>
            <h2 style={{ 
              fontSize: 'clamp(1.3rem, 2.5vw, 1.8rem)', 
              marginBottom: '2.5rem', 
              color: '#C7B381',
              display: 'flex',
              alignItems: 'center',
              gap: '0.8rem',
              fontWeight: '400',
              letterSpacing: '-0.01em',
              flexWrap: 'wrap'
            }}>
              <span style={{ fontSize: '1.8rem' }}></span> Important Terms & Conditions
            </h2>

            <div style={{ 
              display: 'flex',
              flexDirection: 'column',
              gap: 'clamp(1rem, 2vw, 1.5rem)'
            }}>{doc.notes.sort((a, b) => a.orderNumber - b.orderNumber).map((note, index) => (
  <div 
    key={note._id || index} 
    onMouseEnter={() => setHoveredNote(index)}
    onMouseLeave={() => setHoveredNote(null)}
    style={{
      background: hoveredNote === index 
        ? 'rgba(199, 179, 129, 0.08)' 
        : 'rgba(199, 179, 129, 0.05)',
      borderTop: hoveredNote === index
        ? '1px solid rgba(199, 179, 129, 0.4)'
        : '1px solid rgba(199, 179, 129, 0.2)',
      borderRight: hoveredNote === index
        ? '1px solid rgba(199, 179, 129, 0.4)'
        : '1px solid rgba(199, 179, 129, 0.2)',
      borderBottom: hoveredNote === index
        ? '1px solid rgba(199, 179, 129, 0.4)'
        : '1px solid rgba(199, 179, 129, 0.2)',
      borderLeft: '4px solid #C7B381',  // Keep this constant
      padding: 'clamp(1.2rem, 2.5vw, 1.8rem)',
      borderRadius: '12px',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
      boxShadow: hoveredNote === index 
        ? '0 12px 28px rgba(0,0,0,0.4)' 
        : '0 4px 12px rgba(0,0,0,0.2)',
      transform: hoveredNote === index ? 'translateX(8px)' : 'translateX(0)',
      cursor: 'default'
    }}
  >
                  <div style={{ 
                    display: 'flex',
                    gap: 'clamp(0.8rem, 2vw, 1.5rem)',
                    alignItems: 'flex-start'
                  }}>
                    <div style={{
                      minWidth: 'clamp(2rem, 4vw, 3rem)',
                      height: 'clamp(2rem, 4vw, 3rem)',
                      background: 'rgba(199, 179, 129, 0.2)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#C7B381',
                      fontSize: 'clamp(0.9rem, 2vw, 1.2rem)',
                      fontWeight: '700',
                      flexShrink: 0,
                      border: '2px solid rgba(199, 179, 129, 0.3)'
                    }}>
                      {note.orderNumber}
                    </div>
                    
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <h3 style={{ 
                        fontSize: 'clamp(1.1rem, 2vw, 1.4rem)', 
                        fontWeight: '500', 
                        marginBottom: '0.8rem', 
                        color: '#FFFFFF',
                        letterSpacing: '-0.01em',
                        wordBreak: 'break-word'
                      }}>
                        {note.noteTitle}
                      </h3>
                      <p style={{ 
                        fontSize: 'clamp(0.95rem, 1.8vw, 1.05rem)', 
                        lineHeight: '1.8', 
                        color: '#B8B8B8',
                        margin: 0,
                        wordBreak: 'break-word',
                        whiteSpace: 'pre-wrap'
                      }}>
                        {note.noteBody}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Empty State for Notes */}
        {(!doc.notes || doc.notes.length === 0) && doc.fileURL && (
          <div style={{ 
            textAlign: 'center', 
            padding: 'clamp(3rem, 6vw, 5rem)',
            color: '#888',
            background: 'rgba(15, 20, 25, 0.6)',
            border: '1px solid rgba(199, 179, 129, 0.15)',
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem', opacity: 0.3 }}>💡</div>
            <p style={{ fontSize: 'clamp(1rem, 2vw, 1.2rem)', color: '#888' }}>
              No additional terms at this time
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default LeaseToOwnAgreementView;